/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Maëlle MONTINERIb
 * @date        15/10/2019 12:15
 * @copyright   Copyright (c) 2002-2019 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import 'slick-carousel/slick/slick.min';

export class Slider {
    
    constructor()
    {
        this.initializeSlider();
    }
    
    initializeSlider()
    {
        
        let wrapper = $( '.js-slick' );
        
        if ( (window.matchMedia("(max-width: 739px)").matches) && (wrapper.length > 0) ) {
            wrapper.slick( {
               slidesToShow: 2,
               slidesToScroll: 1,
               arrows: false,
               autoplay: true,
               autoplaySpeed: 2500,
               dots: false
           } );
        }
    
        if ( (window.matchMedia("(max-width: 739px)").matches) && (wrapper.length > 0) ) {
            $( '.strateNews .postList' ).slick( {
                slide: '.postItem',
                accessibility: false,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                arrows: false,
                dots: true,
                fade: false,
                pauseOnHover: false
            });
        }
    
        if ( (window.matchMedia("(max-width: 739px)").matches) && (wrapper.length > 0) ) {
            $( '.strateAgenda .eventsList' ).slick( {
                slide: '.eventsListItem',
                accessibility: false,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                arrows: false,
                dots: true,
                fade: false,
                pauseOnHover: false
            });
        }
    
        if ( $('.home').length > 0 ) {
            
            //Slider principal
            $( '#sliderList' ).slick( {
                slide: '.sliderItem',
                accessibility: false,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                arrows: true,
                dots: false,
                fade: true,
                pauseOnHover: false,
                responsive: [
                      {
                          breakpoint: 739,
                          settings:{
                              arrows: false,
                              dots: true,
                              swipe: true,
                          }
                      },
                ]
            });
    
            
            // Slider Best OF
            $('#bestOfList').slick({
               infinite: false,
               speed: 1000,
               autoplay: false,
               autoplaySpeed: 5000,
               arrows: true,
               dots: false,
               pauseOnHover: true,
               centerMode: true,
               slidesToShow: 1,
               focusOnSelect: true,
               variableWidth: true,
               swipe: false,
               responsive: [
                   {
                       breakpoint: 739,
                       settings:{
                           arrows: false,
                           dots: true,
                           initialSlide: 1,
                           variableWidth: true,
                           centerMode: true,
                           swipe: true,
                       }
                   },
               ]
            });
        }
    }
}